import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import ProtectedRoute from 'auth/ProtectedRoute';
import BillingHome from 'components/billing/BillingHome';
import ClinicalDataRecordHome from 'components/clinical-data/ClinicalDataRecordHome';
import DashboardHome from 'components/dashboard/DashboardHome';
import DoctorsHome from 'components/doctors/DoctorsHome';
import GuarantorsHome from 'components/guarantors/GuarantorsHome';
import HomeContent from 'components/HomeContent';
import LabCentralHome from 'components/lab-central/LabCentralHome';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import Header from 'components/layout/Header';
import MedicamentsHome from 'components/medicaments/MedicamentsHome';
import PatientEntryHome from 'components/patient-entry/PatientEntryHome';
import SettingsHome from 'components/settings/SettingsHome';
import { SidebarConsumerRenderProps, withSidebarContext } from 'components/sidebar/SidebarContext';
import SidebarMenu from 'components/sidebar/SidebarMenu';
import TariffHome from 'components/tariffs/TariffHome';
import UserSettingsHome from 'components/user-settings/UserSettingsHome';
import React from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Switch } from 'react-router';
import { Button, Container, Modal } from 'semantic-ui-react';
import styled from 'styled-components';

const MainContentContainer = styled(Container)`
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  margin: 0;

  & .ui.inverted::-webkit-scrollbar-thumb {
    background: #ffffff7d !important;
  }
`;

const LeftContent = styled(Container)`
  flex-grow: 0;
  width: ${props => props.compact ? "60px" : "100px"} !important;
  transition: width 0.55s;
  box-shadow: 1px 0 3px 0 #d5d5d5;
  z-index: 50;
`;

const RightContent = styled(Container)`
  display: flex;
  flex-direction: column;
  flex: 5;
  height: 100vh;
  background: #F3F5F5;
  transition: width 0.55s;
`;

const RightInnerContent = styled(Container)`
  display: flex;
  flex-direction: row;
  padding: 10px 5px 10px 10px;
  overflow-y: auto;
  height: 100%;

`;
const ComponentWrapper = styled.div`
  flex: 4;
  @media only screen and (max-width: 768px) {
    min-height: 70vh;
  }
`;

let idleIntervalId: number | undefined;

const Home = (props: SidebarConsumerRenderProps & AuthConsumerRenderProps & MessageSourceProps) => {

  const {
    sessionExpiredModalOpen,
    onSessionExpiredModalClose,
    onSessionExpiredModalOpen,
    logout,
    getMessage,
    compactView
  } = props;

  // useEffect(() => {
  //
  //   const minutes = true; // change to false if you'd rather use seconds
  //   const interval = minutes ? 60000 : 1000;
  //   const IDLE_TIMEOUT = 15; // in minutes
  //   let idleCounter = 0;
  //
  //   // see:
  //   // https://stackoverflow.com/a/34516735
  //   // https://stackoverflow.com/a/24989958
  //   window.onload = resetTimer;
  //   window.onmousemove = resetTimer;
  //   window.onmousedown = resetTimer;  // catches touchscreen presses as well
  //   window.ontouchstart = resetTimer; // catches touchscreen swipes as well
  //   window.ontouchmove = resetTimer;  // required by some devices
  //   window.onclick = resetTimer;      // catches touchpad clicks as well
  //   window.onkeydown = resetTimer;
  //   window.addEventListener('scroll', resetTimer, true); // improved; see comments
  //
  //   function resetTimer() {
  //     idleCounter = 0;
  //   }
  //
  //   idleIntervalId = window.setInterval(function () {
  //     if (++idleCounter >= IDLE_TIMEOUT) {
  //       onIdle();
  //     }
  //   }, interval);
  //
  //   function onIdle() {
  //     clearInterval(idleIntervalId);
  //     // effectively logs out the user w/out redirecting to the login page
  //     setAccessToken("tokenExpired-idleTimeLimitReached");
  //     onSessionExpiredModalOpen();
  //   }
  //
  //   return () => {
  //     if (idleIntervalId) {
  //       clearInterval(idleIntervalId);
  //       window.removeEventListener('scroll', resetTimer);
  //     }
  //   }
  // }, []);

  return (
      <React.Fragment>
        <Modal
            open={sessionExpiredModalOpen}
            onClose={onSessionExpiredModalClose}
            style={{width: "315px"}}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("sessionExpiredHeader")}</Modal.Header>
          <FormModalContentContainer>{getMessage("sessionExpired")}</FormModalContentContainer>
          <Modal.Actions>
            <Button primary onClick={logout}>{getMessage("header.navigation.logout")}</Button>
            <Button onClick={onSessionExpiredModalClose}>{getMessage("button.close")}</Button>
          </Modal.Actions>
        </Modal>
        <MainContentContainer as="div" compactSidebar={compactView}>
          <LeftContent as="div" compact={compactView}>
            <SidebarMenu/>
          </LeftContent>
          <RightContent as="div" compact={compactView}>
            <Header/>
            <RightInnerContent as="div" fluid>
              <ComponentWrapper className="content-div">
                <Switch>
                  <ProtectedRoute path="/clinical-data-record" component={ClinicalDataRecordHome}/>
                  <ProtectedRoute path="/patient-central" component={PatientEntryHome}/>
                  <ProtectedRoute path="/lab-central" component={LabCentralHome}/>
                  <ProtectedRoute path="/dashboard" component={DashboardHome}/>
                  <ProtectedRoute path="/guarantors" component={GuarantorsHome}/>
                  <ProtectedRoute path="/doctors" component={DoctorsHome}/>
                  <ProtectedRoute path="/medicaments" component={MedicamentsHome}/>
                  <ProtectedRoute path="/tariff" component={TariffHome}/>
                  <ProtectedRoute path="/billing" component={BillingHome}/>
                  <ProtectedRoute path="/settings" component={SettingsHome}/>
                  <ProtectedRoute path="/user-settings" component={UserSettingsHome}/>
                  <ProtectedRoute component={HomeContent}/>
                </Switch>
              </ComponentWrapper>
            </RightInnerContent>
          </RightContent>
        </MainContentContainer>
      </React.Fragment>
  );
};

export default withSidebarContext(withAuthContext(withMessages(Home)));
